<template>
  <div class="max-w-[480px] relative">
    <!-- Prakerja Navbar -->
    <BlNavBarSearchMv
      :value="keywords"
      :has-right-button="isLoggedIn"
      onboarding-step="1"
      placeholder="Cari kelas atau penyedia"
      class="sticky z-40 bg-white top-0 border-b border-b-[#EBEBEB]"
      has-back-button
      @handleBackButtonClick="onCloseWebview"
      @handleClickRightButton="goToTransaksiPage"
      @input="handleSearch"
    >
      <IcoEticket slot="hasRightButtonIcon" />
    </BlNavBarSearchMv>
    <!-- End of Prakerja Navbar -->

    <PrakerjaFilterSortTab
      data-testid="landing-page-filter-tab"
      @leftTabClick="$router.push({name: 'search-location'})"
      @middleTabClick="$router.push({name: 'search-filter'})"
      @rightTabClick="$router.push({name: 'search-sort'})"
    />

    <!-- Prakerja Main Banner -->
    <div class="prakerja-main-banner-wrapper">
      <BlSliderMv
        v-if="getBanners[MAIN_BANNER_TYPE].length"
        :slider-item-margin="0"
        :slider-item-radius="0"
        :slider-item-height="216"
        :slider-item-width="fullScreenWidth"
        :items="getBanners[MAIN_BANNER_TYPE]"
        class="prakerja-main-banner"
        @itemChange="onBannerChange(...arguments, {category: MAIN_BANNER_TYPE})"
        @click="trackBannerOnClick(...arguments, {category: MAIN_BANNER_TYPE})"
      />
    </div>
    <!-- End of Prakerja Main Banner -->

    <!-- Prakerja Announcement -->
    <div class="relative">
      <BlAnnouncementMv
        v-if="getAnnouncements.list.length"
        :content="getAnnouncements.list"
        :is-show-close-button="getAnnouncements.isCloseable"
        is-close-per-content
        @close="trackCloseAnnouncement"
        @change="trackImpressionAnnouncement"
        @clickAction="trackShowMoreAnnouncement"
      />
    </div>
    <!-- End of Prakerja Announcement -->
    <PrakerjaGamification />

    <!-- Prakerja Purchased Course -->
    <PrakerjaPurchasedCourse coachmark-purchased-step="1" />
    <!-- End of Prakerja Purchased Course -->

    <!-- Prakerja Green Box -->
    <PrakerjaBestCourses />
    <!-- End of Prakerja Green Box -->

    <!-- Prakerja Kelas Terdekat -->
    <PrakerjaKelasTerdekat v-if="isClosestCourseActive" />
    <!-- End of Prakerja  Kelas Terdekat -->

    <PrakerjaCategoryAndMerchantTab onboarding-step="2" />

    <!-- Prakerja Second Banner -->
    <div class="prakerja-second-banner-wrapper pv-16">
      <BlSliderMv
        v-if="getBanners[SECOND_BANNER_TYPE].length"
        :slider-item-margin="isHaveOnlyOneSecondaryBanner ? 0 : undefined"
        :slider-item-height="130"
        :slider-item-width="fullScreenWidth - 32"
        :items="getBanners[SECOND_BANNER_TYPE]"
        :class="['prakerja-second-banner', isHaveOnlyOneSecondaryBanner && 'prakerja-second-banner--centered']"
        @itemChange="onBannerChange(...arguments, {category: SECOND_BANNER_TYPE})"
        @click="trackBannerOnClick(...arguments, {category: SECOND_BANNER_TYPE})"
      />
    </div>
    <!-- End of Prakerja Second Banner -->

    <PrakerjaDynamicSection category="prakerja-landing-primary" />
    <PrakerjaCoursesWithTab v-if="getIsEnableLandingPageCategorySection" />

    <div class="w-full h-3 bg-[#f2f2f2]"></div>

    <PrakerjaGuidance onboarding-step="3" />
    <PrakerjaMerchantRegistrationBanner />
    <div class="w-full h-3 bg-[#f2f2f2]"></div>
    <PrakerjaPageArticle :content="PRAKERJA_META.article" />
    <PrakerjaFooter />

    <div
      v-if="isLoggedIn && !isOnboarded"
      onboarding-step="4"
      class="qa-onboard-ticket absolute top-0 right-0 p-16"
      style="width: 56px; height: 56px"
    >
      <IcoEticket />
    </div>

    <!-- Please ignore the eslint error in the line of code: `v-if="tour.currentStep === index"`, it is required by the v-step component -->
    <v-tour name="onBoardingInfo" :steps="steps" :options="{useKeyboardNavigation: false}">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-for="(step, index) of tour.steps"
            v-if="tour.currentStep === index"
            :key="index"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <div v-if="tour.steps.length > 1" slot="content" class="onboarding-indicator-wrapper">
              <BlSliderIndicatorAv :count="steps.length" :active="tour.currentStep + 1" />
            </div>
            <BlTextAv v-if="step.content" slot="content">{{ step.content }}</BlTextAv>
            <BlFlexContainerMv slot="actions" class="mt-20" justify-content="flex-end">
              <BlButtonAv v-if="!tour.isFirst" size="small" variation="link" class="mr-20" @click="tour.previousStep">Kembali</BlButtonAv>
              <BlButtonAv v-if="!tour.isLast" size="small" @click="tour.nextStep">Lanjut</BlButtonAv>
              <BlButtonAv v-else size="small" @click="onFinishBoarding(step)">
                {{ step.target === '[coachmark-purchased-step="1"]' ? 'Oke' : 'Tutup' }}
              </BlButtonAv>
            </BlFlexContainerMv>
          </v-step>
        </transition>
      </template>
    </v-tour>

    <PrakerjaChangePhoneNumber v-if="isLoadChangePhoneNumber" />
  </div>
</template>

<script>
import PrakerjaFooter from '../components/PrakerjaLandingPage/PrakerjaFooter.vue';
import PrakerjaMerchantRegistrationBanner from '../components/PrakerjaLandingPage/PrakerjaMerchantRegistrationBanner.vue';
import PrakerjaBestCourses from '../components/PrakerjaLandingPage/PrakerjaBestCourses.vue';
import PrakerjaKelasTerdekat from '../components/PrakerjaLandingPage/PrakerjaKelasTerdekat.vue';
import PrakerjaPurchasedCourse from '../components/PrakerjaLandingPage/PrakerjaPurchasedCourse.vue';
import {mapGetters} from 'vuex';
import {BlNavBarSearchMv, BlSliderMv, BlAnnouncementMv, BlButtonAv, BlSliderIndicatorAv} from '@bukalapak/bazaar-mweb-latest';
import {IcoEticket} from '@bukalapak/bazaar-visual-next';
import PrakerjaGuidance from '../components/PrakerjaLandingPage/PrakerjaGuidance';
import PrakerjaPageArticle from '../components/PrakerjaLandingPage/PrakerjaPageArticle';
import PrakerjaCategoryAndMerchantTab from '../components/PrakerjaLandingPage/PrakerjaCategoryAndMerchantTab';
import PrakerjaDynamicSection from '../components/shared/PrakerjaDynamicSection.vue';
import PrakerjaFilterSortTab from '../components/PrakerjaSearchPage/PrakerjaFilterSortTab.vue';
import PrakerjaChangePhoneNumber from '../components/PrakerjaBottomSheet/PrakerjaChangePhoneNumber.vue';
import PrakerjaGamification from '../components/PrakerjaLandingPage/PrakerjaGamification.vue';

import trackerGenerator from '../mixins/tracker-generator';
import {MAIN_BANNER_TYPE, SECOND_BANNER_TYPE} from '../config/app';

import {
  TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_CLOSE,
  TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_IMPRESSION,
  TRACKER_EVENT_VP_PRAKERJA_BANNER_CLICK,
  TRACKER_EVENT_VP_PRAKERJA_BANNER_SECONDARY_CLICK,
  TRACKER_EVENT_VP_PRAKERJA_BANNER_SECONDARY_VIEW,
  TRACKER_EVENT_VP_PRAKERJA_BANNER_VIEW,
  TRACKER_EVENT_VP_PRAKERJA_ICON_COUPON_CLICK,
  TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_SHOW_MORE,
  TRACKER_EVENT_VP_PRAKERJA_ONBOARDING_VIEW,
  TRACKER_EVENT_VP_PRAKERJA_ONBOARDING_CLOSE,
  TRACKER_EVENT_VP_PRAKERJA_LANDING_PAGE_VIEW,
  TRACKER_EVENT_VP_PRAKERJA_COUPON_LIST,
} from '../config/tracker-events';
import cloneDeep from 'lodash/cloneDeep';

import Braze from 'shared_js/helpers/braze';

import PRAKERJA_META from '../../../../config/meta/kartu-prakerja';
import prakerjaPurchasedCourses from 'src/shared/mixins/prakerja-purchased-course';
import nativeHandler from 'src/shared/mixins/native-handler';
const defaultBannerImpression = {
  activeIndex: 1,
  impressionTrackedIds: [],
};

export default {
  name: 'PrakerjaLandingPage',
  components: {
    BlNavBarSearchMv,
    BlSliderMv,
    BlAnnouncementMv,
    BlSliderIndicatorAv,
    BlButtonAv,
    IcoEticket,
    PrakerjaGuidance,
    PrakerjaCategoryAndMerchantTab,
    PrakerjaDynamicSection,
    PrakerjaCoursesWithTab: () => import('../components/PrakerjaLandingPage/PrakerjaCoursesWithTab'),
    PrakerjaBestCourses,
    PrakerjaMerchantRegistrationBanner,
    PrakerjaFooter,
    PrakerjaPageArticle,
    PrakerjaFilterSortTab,
    PrakerjaChangePhoneNumber,
    PrakerjaKelasTerdekat,
    PrakerjaPurchasedCourse,
    PrakerjaGamification,
  },
  mixins: [trackerGenerator, prakerjaPurchasedCourses, nativeHandler],
  data() {
    return {
      MAIN_BANNER_TYPE,
      SECOND_BANNER_TYPE,
      PRAKERJA_META,
      banners: {
        [MAIN_BANNER_TYPE]: {
          ...cloneDeep(defaultBannerImpression),
          impressionTrackerName: TRACKER_EVENT_VP_PRAKERJA_BANNER_VIEW,
          clickTrackerName: TRACKER_EVENT_VP_PRAKERJA_BANNER_CLICK,
        },
        [SECOND_BANNER_TYPE]: {
          ...cloneDeep(defaultBannerImpression),
          impressionTrackerName: TRACKER_EVENT_VP_PRAKERJA_BANNER_SECONDARY_VIEW,
          clickTrackerName: TRACKER_EVENT_VP_PRAKERJA_BANNER_SECONDARY_CLICK,
        },
      },
      keywords: '',
      trackedAnnouncements: [],
      steps: [
        {
          target: '[onboarding-step="1"]', // We're using document.querySelector() under the hood
          content: `Cari kelas sesuai minat kamu melalui menu pencarian ini.`,
          params: {
            highlight: true,
          },
        },
        {
          target: '[onboarding-step="2"]',
          content: 'Kamu bisa cari kelas berdasarkan kategori atau lembaga pelatihan.',
          params: {
            highlight: true,
          },
        },
        {
          target: '[onboarding-step="3"]',
          content: 'Setelah membeli voucher, cara penukaran bisa kamu cek di sini.',
          params: {
            highlight: true,
          },
        },
        {
          target: '[onboarding-step="4"]',
          content: 'Lihat semua transaksi pembelian voucher kelas dari menu ini.',
          params: {
            highlight: true,
          },
        },
      ],
      purchasedCouponCoachmark: {
        target: '[coachmark-purchased-step="1"]', // We're using document.querySelector() under the hood
        content: `Cek voucher kelas yang udah kamu beli di sini untuk penukaran.`,
        params: {
          highlight: true,
        },
      },
      isLoadChangePhoneNumber: false,
    };
  },
  computed: {
    ...mapGetters('banners', ['getBanners']),
    ...mapGetters('announcements', ['getAnnouncements']),
    ...mapGetters(['getPreviousPage', 'getIsEnableLandingPageCategorySection']),
    ...mapGetters('sections', ['getClosestCoursesConfig']),
    isClosestCourseActive() {
      return this.getClosestCoursesConfig?.toggle || false;
    },
    isLoggedIn() {
      return !!window.USER?.id;
    },
    fullScreenWidth() {
      let width = window.innerWidth;
      if (width > 480) width = 480;

      return width;
    },
    isOnboarded() {
      return JSON.parse(window.localStorage.getItem('isOnboarded')) === true;
    },
    shownPurchasedCoachmark() {
      return JSON.parse(window.localStorage.getItem('shownPurchasedCoachmark')) === true;
    },
    isHaveOnlyOneSecondaryBanner() {
      return this.getBanners[SECOND_BANNER_TYPE].length === 1;
    },
  },
  watch: {
    isShow(value) {
      if (value && !this.isOnboarded && !this.shownPurchasedCoachmark) {
        this.steps.push(this.purchasedCouponCoachmark);
        this.trackShowCoachmark();
      } else if (value && this.isOnboarded && !this.shownPurchasedCoachmark) {
        this.steps = [this.purchasedCouponCoachmark];
        this.$tours['onBoardingInfo'].start();
        this.trackShowCoachmark();
      }
    },
  },
  beforeMount() {
    this.initilize();
  },
  mounted() {
    this.initOnBoardingInfo();
    Braze.sendEvent('prakerja_homepage_visit');
  },
  methods: {
    initilize() {
      this.$store.commit('courses/resetCoursesFilter');
      this.$store.dispatch('sections/fetchPrakerjaClosestCoursesConfig');
      this.resetCourses();
      this.initBanners();
      this.initAnnouncements();
      this.trackLandingPage();
    },
    initOnBoardingInfo() {
      if (this.isOnboarded) {
        // only update load change phone number when coachmark is already shown or nor shown but have purchased coupon
        if ((!this.shownPurchasedCoachmark && !this.isShow) || this.shownPurchasedCoachmark) this.isLoadChangePhoneNumber = true;
        return;
      }

      if (!this.isLoggedIn) this.steps = this.steps.slice(0, this.steps.length - 1);
      this.$tours['onBoardingInfo'].start();
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_ONBOARDING_VIEW);
    },
    onFinishBoarding(step) {
      this.$tours['onBoardingInfo'].finish();
      this.isLoadChangePhoneNumber = true;
      // onboarding normal has 4 step so we can utilize this
      if (this.steps.length > 1) {
        this.saveHistoryOnboarding();
        this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_ONBOARDING_CLOSE);
      }

      if (step.target === '[coachmark-purchased-step="1"]') {
        this.saveHistoryCoachmarkPurchased();
        // do track coachmark close
        const trackerPayload = {
          action: 'close_coachmark',
        };
        this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_COUPON_LIST, trackerPayload);
      }
    },
    async initBanners() {
      this.onBannerChange(1, {category: MAIN_BANNER_TYPE});
      await this.$store.dispatch('banners/fetchBanners', {type: SECOND_BANNER_TYPE});
      this.onBannerChange(1, {category: SECOND_BANNER_TYPE});
    },
    async initAnnouncements() {
      await this.$store.dispatch('announcements/fetchAnnouncements');
      if (this.getAnnouncements.list.length) this.trackImpressionAnnouncement(this.getAnnouncements.list[0]);
    },
    resetCourses() {
      if (['search', 'merchant'].includes(this.getPreviousPage?.name)) {
        this.$store.commit('courses/resetCourses');
        this.$store.commit('categories/setSelectedCategory', null);
      }
    },
    // This method is used for close webview then go back to BL apps
    onCloseWebview() {
      this.closeNative(() => {
        window.history.back();
      });
    },
    handleSearch(value) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      this.searchTimeout = setTimeout(() => {
        const lowercasedKeyword = value.toLowerCase();
        this.$store.commit('courses/resetCoursesFilter');
        this.$store.commit('courses/resetCourses');
        this.$store.commit('categories/setSelectedCategory', 'all');
        this.$store.commit('courses/setCoursesFilter', {keywords: lowercasedKeyword});
        this.$router.push({name: 'search', query: {...this.$route.query, keyword: lowercasedKeyword}});
      }, 800);
    },

    async goToTransaksiPage() {
      this.trackPrakerjaIconCoupon();
      this.$router.push({name: 'transaksi'});
    },
    onBannerChange(currentActiveBannerIndex, {category = SECOND_BANNER_TYPE}) {
      let banners = this.getBanners[category];

      let updatedActiveIndex = (currentActiveBannerIndex - 1) % banners.length;
      if (updatedActiveIndex < 0) updatedActiveIndex = banners.length + updatedActiveIndex;

      this.banners[category].activeIndex = updatedActiveIndex + 1;
      this.sendBannerImpressionTracker({category});
    },
    sendBannerImpressionTracker({category}) {
      let bannerImpressionTrackedIds = this.banners[category].impressionTrackedIds;
      let bannerActiveIndex = this.banners[category].activeIndex;
      let impressionTrackerName = this.banners[category].impressionTrackerName;
      let banners = this.getBanners[category];

      const isBannerAlreadyTracked = bannerImpressionTrackedIds.includes(bannerActiveIndex);
      const isHaveToTrackBanner = banners.length && !isBannerAlreadyTracked;
      if (!isHaveToTrackBanner) return;

      const trackerPayload = {
        banner_name: banners[bannerActiveIndex - 1].title,
        banner_url: banners[bannerActiveIndex - 1].url,
        banner_position: banners[bannerActiveIndex - 1].order.toString(),
      };

      this.mixinSendTracker(impressionTrackerName, trackerPayload);
      bannerImpressionTrackedIds.push(bannerActiveIndex);
    },
    trackBannerOnClick(banner, {category = MAIN_BANNER_TYPE}) {
      let trackerName = this.banners[category].clickTrackerName;
      const trackerPayload = {
        banner_name: banner.title,
        banner_url: banner.url,
        banner_position: banner.order.toString(),
      };

      this.mixinSendTracker(trackerName, trackerPayload);
    },
    trackPrakerjaIconCoupon() {
      return this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_ICON_COUPON_CLICK);
    },
    trackCloseAnnouncement(item) {
      const trackerPayload = {announcement_title: item.title};
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_CLOSE, trackerPayload);
    },
    trackImpressionAnnouncement(item) {
      if (this.trackedAnnouncements.includes(item.id)) return;

      const trackerPayload = {
        announcement_title: item.title,
        show_more: !!item.action,
        closable: this.getAnnouncements.isCloseable,
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_IMPRESSION, trackerPayload);
      this.trackedAnnouncements.push(item.id);
    },
    trackShowMoreAnnouncement(item) {
      const trackerPayload = {
        announcement_title: item.title,
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_ANNOUNCEMENT_SHOW_MORE, trackerPayload);
    },
    trackShowCoachmark() {
      const trackerPayload = {
        action: 'show_coachmark',
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_COUPON_LIST, trackerPayload);
    },
    saveHistoryOnboarding() {
      window.localStorage.setItem('isOnboarded', true);
    },
    saveHistoryCoachmarkPurchased() {
      window.localStorage.setItem('shownPurchasedCoachmark', true);
    },
    trackLandingPage() {
      const trackerPayload = {
        deep_scroll: 0,
      };
      this.mixinSendTracker(TRACKER_EVENT_VP_PRAKERJA_LANDING_PAGE_VIEW, trackerPayload);
    },
  },
};
</script>

<style lang="scss" scoped>
.prakerja-second-banner-wrapper,
.prakerja-main-banner-wrapper {
  .bl-slider::v-deep img {
    width: 100% !important;
    object-fit: cover !important;
  }

  .bl-slider.prakerja-second-banner--centered::v-deep .bl-slider__display {
    display: flex;
    justify-content: center;
  }
}

// Vue tour additional style
.v-step {
  background: #ffffff !important;
  text-align: left !important;
  width: 280px !important;
}

.v-step[x-placement^='bottom'] .v-step__arrow {
  border-bottom-color: #ffffff !important;
}

.v-step[x-placement^='top'] .v-step__arrow {
  border-top-color: #ffffff !important;
}

.v-tour__target--highlighted {
  box-shadow: none !important;
  pointer-events: auto;
  background: #ffffff;
  z-index: 9999;
}

// End Of Vue tour additional style
</style>
